import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default class DashboardButton extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		if (this.props.page === "home") {
			return (
				<Link to={"/kingstonhome/"}>
					<FontAwesomeIcon
						icon={faArrowLeft}
						// onClick={this.w3_close}
						// className={styles.arrowLeft}
					/>
					{" Back To Home"}
				</Link>
			);
		} else {
			return (
				<Link to={"/kingstonconnect/"}>
					<FontAwesomeIcon
						icon={faArrowLeft}
						// onClick={this.w3_close}
						// className={styles.arrowLeft}
					/>
					{" Back To Dashboard"}
				</Link>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/BackToDashboard.js